/**
 * @generated SignedSource<<2af32ad27febef757b105730b8000a19>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerApplicationBenefits_viewer$data = {
  readonly newSellerPricing: boolean | null;
  readonly " $fragmentType": "SellerApplicationBenefits_viewer";
};
export type SellerApplicationBenefits_viewer$key = {
  readonly " $data"?: SellerApplicationBenefits_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SellerApplicationBenefits_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SellerApplicationBenefits_viewer",
  "selections": [
    {
      "alias": "newSellerPricing",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "newSellerPricing"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"newSellerPricing\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "71efe5ddd4fd261e1eab3f0d347fdbc4";

export default node;
